import {IAdequacyByCountyTableRow, IAllSpecialtyCountyData, IFacilityType} from '../types';
import ReportsTable from './tables/ReportsTable';
import tableHeaders from './tables/table-headers';

interface ISpecialtyStandardsProps {
    specialtyCountyData: IAllSpecialtyCountyData['data'][string] | null,
    loading: boolean,
    error?: string | null,
    providerType: IFacilityType
}

const SpecialtyStandards = (props: ISpecialtyStandardsProps) => {
    const {specialtyCountyData, loading, error, providerType} = props;

    const getStatus = (value: string) => {
        const isPassing = value === '1';
        const bgColor = isPassing ? '#D6E9FF' : '#FFE6E6';
        const textColor = isPassing ? '#0078D4' : '#D13438';
        const label = isPassing ? 'Pass' : 'Fail';
        return (
            <span className="status-tag" style={{
                backgroundColor: bgColor,
                color: textColor
            }}>
                {label}
            </span>
        );
    };

    const getLabel = (value: string) => {
        const parsedValue = +(value || '0') * 100;
        const isFailing = parsedValue < 90;
        return (
            <>
                {isFailing && <span className="fail-icon">✕</span>}
                {parsedValue.toFixed(2)}%
            </>
        );
    };

    const getTableCellLabels = (row: IAdequacyByCountyTableRow) => {
        //Show county name alowith ssacd
        const countyName = `${row.county_name} - ${row.ssacd}`;

        return [
            <b key={countyName}>{countyName}</b>,
            row.county_designation,
            row.num_providers_within_td,
            ...(providerType === 'Facility' ? [row.num_beds_available] : []),
            row.county_members,
            `${(+(row.target_pct || '0') * 100).toFixed(2)}%`,
            getLabel(row.distance_pct),
            getLabel(row.time_pct),
            getStatus(row.status),
            row.additional_providers_within_td,
        ];
    };

    return (
        <ReportsTable
            className='county-table'
            headers={tableHeaders.getAdequacyByCountyTableHeaders(providerType)}
            rows={specialtyCountyData || []}
            getTableCellLabels={getTableCellLabels}
            loading={loading}
            error={error}
            loadingRows={19}
            loadingColumns={10}
        />
    );
};

export default SpecialtyStandards;
